// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-78049aca] .v-expansion-panel-header__icon {\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n@media (pointer: none), (pointer: coarse) {\n[data-v-78049aca] .v-expansion-panel-content__wrap {\n    padding: 0;\n}\n}", ""]);
// Exports
module.exports = exports;
